import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';
import { RealtorCollaborationRequest, updateRealtorCollaborationRequest } from '../types/realtorCollaborationRequest';


export const getCollaborationRequests = async (id : number) => {
  try {
    const response = await axios.get(`${API_URL}/realtor-collaboration-requests/${id}`, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    if(response.status === 200) {
      return response.data;
    }
  } catch (error: any) {
    console.error("Error in getCollaborationRequests:", error);
    throw new Error(error.response?.data || error.message || 'An unknown error occurred');
  }
};

export const createCollaborationRequest = async (data: RealtorCollaborationRequest) => {
  try {
    const response = await axios.post(`${API_URL}/realtor-collaboration-requests`, data, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    if(response.status === 201) {
        return response.data;
        }
    } catch (error: any) {
    console.error("Error in createCollaborationRequest:", error.response.data);
    throw new Error(error.response?.data || error.message || 'An unknown error occurred');
  }
}

export const updateCollaborationRequest = async (id: number, data: updateRealtorCollaborationRequest) => {
  try {
    const response = await axios.put(`${API_URL}/realtor-collaboration-requests/${id}`, data, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    if(response.status === 200) {
      console.log(response.data.data)
      return response.data;
    }
  } catch (error: any) {
    console.error("Error in updateCollaborationRequest:", error.response.data);
    throw new Error(error.response.data || error.message || 'An unknown error occurred');
  }
};

export const getByRealtorId = async (realtorId: number) => {
  try {
    const response = await axios.get(`${API_URL}/realtor-collaboration-requests/get-by-realtor/${realtorId}`, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
    });
    if(response.status === 200) {

        return response.data;
        }

    }
    catch (error: any) {
    console.error("Error in getByRealtorId:", error);
    throw new Error(error.response.data || error.message || 'An unknown error occurred');
    }
}

export const getByPropertyId = async (propertyId: number) => {
    try {
        const response = await axios.get(`${API_URL}/realtor-collaboration-requests/get-by-property/${propertyId}`, {
        headers: {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        });
        if(response.status === 200) {
            return response.data;
        }   
    }
    catch (error: any) {
        console.error("Error in getByPropertyId:", error);
        throw new Error(error.response?.data || error.message || 'An unknown error occurred');
    }
}

export const getByRealtorAndPropertyId = async (realtorId: number, propertyId: number) => {
    try {
        const response = await axios.get(`${API_URL}/realtor-collaboration-requests/get-by-realtor/${realtorId}/property/${propertyId}`, {
        headers: {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        });
        if(response.status === 200) {
            return response.data;
        }   
    }
    catch (error: any) {
        console.error("Error in getByRealtorAndPropertyId:", error);
        throw new Error(error.response.data || error.message || 'An unknown error occurred');
    }
}

export const acceptCollaborationRequest = async (id: number) => {
  try {
    const response = await axios.put(`${API_URL}/realtor-collaboration-requests/accept/${id}`, {}, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    if(response.status === 200) {
      return {success: true, message: "Colaboración aceptada correctamente.", data: response.data}
    }  
    }
    catch (error: any) {
    console.error("Error in acceptCollaborationRequest:", error.response);
    return {success: false, message : error.response.data || error.message || 'An unknown error occurred', data: null};
    }
}
export const rejectCollaborationRequest = async (id: number) => {
  try {
    const response = await axios.put(`${API_URL}/realtor-collaboration-requests/reject/${id}`, {}, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
    });
    if(response.status === 200) {
        return response.data;
        }
    }
    catch (error: any) {
    console.error("Error in rejectCollaborationRequest:", error);
    throw new Error(error.response.data || error.message || 'An unknown error occurred');
    }
};
